module.exports = __webpack_public_path__ + "static/media/master.8f28375c.svg";